<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Редагування Техніка" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-card class="mb-3" title="Image *">
                  <div v-if="imgExisting">
                    <a style="display: block;" target="_blank" :href="imgExisting"><img style="max-width: 400px;" :src="imgExisting"></a>
                    <div><va-button small color="danger" @click="imgExisting = deleteImage(imgId) ? '' : imgExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    @input="delete errors.image"
                    type="gallery"
                    dropzone
                    v-model="img"
                    style="margin-bottom: 25px;"
                  />
                  <div v-if="errors.image" style="color: red;">{{ this.errors.image[0] }}</div>
                  <va-button @click="uploadImage('image', 'MachineryImage', 'Machinery[image]', img[0])">Завантажити</va-button>
                </va-card>
                <va-input
                  label="Label *"
                  v-model="label"
                  :messages="['The recommended number of characters is 255']"
                  @input="delete errors.label"
                  :error="!!errors.label"
                  :error-messages="errors.label"
                />
                <va-input
                  label="Models *"
                  v-model="models"
                  type="textarea"
                  :messages="['The recommended number of characters is 100']"
                  @input="delete errors.models"
                  :error="!!errors.models"
                  :error-messages="errors.models"
                />
                <va-input
                  label="Content *"
                  v-model="content"
                  type="textarea"
                  :messages="['The recommended number of characters is 1000']"
                  @input="delete errors.content"
                  :error="!!errors.content"
                  :error-messages="errors.content"
                />
                <va-card
                  title="Characteristics"
                  style="margin-bottom: 25px;"
                >
                  <va-button style="margin-bottom: 10px;" small @click="addInput">Додати</va-button>
                  <div v-for="(input, index) in charInputs" :key="index">
                    <va-input
                      :label="`Characteristics ${index+1}`"
                      v-model="charInputs[index].content"
                      style="margin-bottom: 10px;"
                      :error="!!errors[`characteristics[${index}][content]`]"
                      :error-messages="errors[`characteristics[${index}][content]`]"
                      @input="delete errors[`characteristics[${index}][content]`]"
                    />
                    <va-button style="margin-bottom: 30px;" v-if="charInputs.length > 0" color="danger" small @click="removeInput(index)">Видалити</va-button>
                  </div>
                </va-card>
                <va-toggle label="Test" small v-model="test"/>
                <va-toggle label="Published" small v-model="published"/>
                <va-input
                  label="Position"
                  v-model.number="position"
                  @input="delete errors.position"
                  :error="!!errors.position"
                  :error-messages="errors.position"
                />
                <va-button @click="submit()">Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      img: [],
      imgExisting: '',
      imgId: '',
      label: '',
      models: '',
      content: '',
      charInputs: [],
      position: '',
      test: false,
      published: false,

      sign: '',

      errors: [],

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
    const generateRandomString = (length = 6) => Math.random().toString(20).substr(2, length)
    this.sign = generateRandomString(32)
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    uploadImage (attr, entityAttribute, param, file) {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append('model_name', 'backend\\modules\\machinery\\models\\Machinery')
      formData.append('attribute', attr)
      formData.append('entity_attribute', entityAttribute)
      formData.append(param, file)
      formData.append('file_id', '0')
      formData.append('multiple', '0')
      if (this.$attrs.id) {
        formData.append('id', this.$attrs.id)
      } else {
        formData.append('sign', this.sign)
      }

      axios.post(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id) {
      return axios.delete(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/upload/${id}`)
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    addInput () {
      this.charInputs.push({
        content: '',
      })
    },
    removeInput (index) {
      this.charInputs.splice(index, 1)
    },
    submit () {
      const data = {
        label: this.label,
        position: this.position,
        published: !!this.published,
        unique: !!this.test,
        models: this.models,
        content: this.content,
        characteristics: this.charInputs.length ? this.charInputs : null,
        sign: this.sign ? this.sign : null,
      }
      if (this.$attrs.id) { // update
        axios.put(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/machinery/${this.$attrs.id}`, data)
          .then(response => {
            this.$router.push({ name: 'autostrada-widgets-machinery' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      } else {
        axios.post(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/machinery`, data)
          .then(response => {
            this.$router.push({ name: 'autostrada-widgets-machinery' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      if (this.$attrs.id) {
        axios.get(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/machinery/${this.$attrs.id}`)
          .then(response => {
            console.log(response.data)
            this.label = response.data.label
            this.position = response.data.position
            this.models = response.data.models
            this.test = !!response.data.unique
            this.published = !!response.data.published
            this.content = response.data.content
            if (response.data.characteristics) {
              this.charInputs = response.data.characteristics
            }

            this.imgExisting = process.env.VUE_APP_AUTOSTRADA_ADMIN + response.data.image.originalSrc
            this.imgId = response.data.imageId
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
